module.exports = __webpack_public_path__ + "assets/img/NVIDIA-9ac00f9b.png";